function Observable(obj, keys) {
    var depActions = {};
    if (!keys || keys.length == 0) {
        keys = Object.keys(obj);
    }
    function notify(key) {
        if (!depActions[key] || depActions[key].length < 1)
            return;
        depActions[key].forEach(function (action) { return action(key, obj[key]); });
    }
    function observe(property, actionHandler) {
        if (!depActions[property])
            depActions[property] = [];
        depActions[property].push(actionHandler);
        if (!obj.hasOwnProperty(property)) {
            makeReactive(obj, property);
        }
    }
    function makeReactive(obj, key) {
        var val = obj[key];
        Object.defineProperty(obj, key, {
            get: function () {
                return val;
            },
            set: function (newVal) {
                val = newVal;
                notify(key);
            },
        });
    }
    keys.forEach(function (key) { return makeReactive(obj, key); });
    return {
        data: obj,
        observe: observe,
        notify: notify,
    };
}
export { Observable };
